import { type AxiosInstance } from 'axios';
import { getAuthToken, removeAuthToken } from '@/utils/auth-token';

export const getHeaders = () => {
  const token = getAuthToken();
  if (!token) return {};

  return {
    Authorization: `Bearer ${token}`,
    'X-Authorization': `Bearer ${token}`,
  };
};

const withResponseHandler = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response.data,
    (error) => {
      const endpoint = error.config?.url;
      const status = error.response?.status;
      const userIsUnauthorized =
        endpoint?.includes('bootstrap_data') && status === 401;

      if (userIsUnauthorized) {
        removeAuthToken();
      }

      return Promise.reject(error);
    }
  );
};

export const withAuthorization = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use((request) => {
    const headers = getHeaders();
    const isLogged = headers['Authorization'];

    if (isLogged) {
      Object.entries(headers).forEach(([key, value]) => {
        request.headers.set(key, value);
      });
    }

    return request;
  });

  withResponseHandler(axiosInstance);

  return axiosInstance;
};

export const withCookieAuth = (axiosInstance: AxiosInstance) => {
  axiosInstance.defaults.withCredentials = true;

  withResponseHandler(axiosInstance);

  return axiosInstance;
};
